import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type Mode = "display" | "edit";

interface IContextProps {
  editingId?: string;
  mode: Mode;
  setMode: (id: string, mode: Mode) => void;
}

const GlobalEditingStateContext = createContext<IContextProps>({
  editingId: undefined,
  mode: "display",
  setMode: () => {},
});

export interface IProviderProps {
  children?: ReactNode;
}

export const GlobalEditingStateProvider = ({ children }: IProviderProps) => {
  const [editingId, setEditingId] = useState<string>();
  const [mode, setMode] = useState<Mode>("display");

  const _setMode = useCallback(
    (id: string, newMode: Mode) => {
      setEditingId(id);
      setMode(newMode);
    },
    [setMode],
  );

  const value = useMemo<IContextProps>(
    () => ({
      editingId,
      mode,
      setMode: _setMode,
    }),
    [editingId, mode, _setMode],
  );

  return (
    <GlobalEditingStateContext.Provider value={value}>
      {children}
    </GlobalEditingStateContext.Provider>
  );
};

export const useGlobalEditingState = () =>
  useContext(GlobalEditingStateContext);
